import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children"];
import React, { forwardRef, memo } from 'react';
import styled from 'styled-components';
import { useChildrenValidation } from '../../hooks/useChildrenValidation';
import { TabItem } from './TabItem';
var TabContentWrapper = styled.div.withConfig({
  displayName: "TabContent__TabContentWrapper",
  componentId: "sc-1j79js7-0"
})(["position:relative;width:100%;height:100%;flex-shrink:1;"]);
export var TabContent = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      styleProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  useChildrenValidation(children, 'Tab.Content', TabItem);
  return /*#__PURE__*/React.createElement(TabContentWrapper, _extends({}, styleProps, {
    "data-test": "tab-content",
    ref: ref
  }), children);
}));
TabContent.displayName = 'Tab.Content';